export default {
  title: 'Wygląda na to, że jesteś offline',
  description: 'Kliknij „Przeładuj stronę" i/lub sprawdź połączenie internetowe, aby upewnić się, że jesteś online 😊',
  custom_button: {
    reload: 'Przeładuj stronę',
  },
};
